import { createFileRoute } from "@tanstack/react-router"
import CoreKanbanPage from "@/components/coreKanban/CoreKanbanPage"

export const Route = createFileRoute("/core/kanban/")({ component: CoreKanbanPage })
